import { useQuery } from "@tanstack/react-query";
import { notification } from "antd";
import { fetchData } from "../../utils";

export const useGetAllOrders = () => {
  return useQuery({
    queryKey: ["getAllOrders"], // ✅ static key
    queryFn: () => fetchData("/vendor/getallorder"), // ✅ no params
    staleTime: 5 * 60 * 1000, // ✅ optional - keeps data fresh for 5 min
    refetchOnWindowFocus: false, // ✅ optional - avoid refetch when switching tabs
    onError: () =>
      notification.error({
        key: "getAllOrdersError",
        message: "Failed to retrieve Orders",
      }),
  });
};
